<template>
  <div class="header_container">
    <div class="content_left font1">全能i家运营平台</div>
    <div class="content_right">
      <!-- <Icon type="md-expand" size="26" class="margin_right icon_hover" @click="toggleFullScreen" />
      <Icon type="ios-bug-outline" size="26" class="margin_right icon_hover" />
      <Badge :count="9" type="info" class="margin_right">
        <Icon type="ios-notifications-outline" size="26" class="icon_hover" />
      </Badge> -->
      <Dropdown>
        <a href="javascript:void(0)" class="wrap_avatar">
          <Avatar
            src="https://i.loli.net/2017/08/21/599a521472424.jpg"
            class="avatar"
          />
          <Icon type="ios-arrow-down" />
        </a>
        <DropdownMenu slot="list">
          <ul class="wrap_droparea">
            <li @click="goto('/resetpasswd')">
              <Sicon class="sicon" type="#icon-xiugaimima" />
              <span class="font5_gray">修改密码</span>
            </li>
            <li @click="logout">
              <Sicon class="sicon" type="#icon-tingyong" />
              <span class="font5_gray">退出</span>
            </li>
          </ul>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: window.userInfo || localStorage.getItem("userInfo"),
    };
  },
  methods: {
    async logout() {
      let userInfo = window.userInfo || localStorage.getItem("userInfo");
      this.$router.push("login");
      setTimeout(() => {
        location.reload();
      }, 200);
    },
    goto(path) {
      this.$router.push(path);
    },
    toggleFullScreen() {
      !document.fullscreenElement
        ? document.documentElement.requestFullscreen()
        : document.exitFullscreen();
    },
  },
};
</script>
<style lang="less" scoped>
.header_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  height: 54px;
  width: 100%;
  z-index: 99;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 14px 0px rgba(224, 229, 238, 0.5);
}
.content_left {
  width: 240px;
  text-align: center;
}
.content_center {
  flex: 1;
}
.content_right {
  display: flex;
  align-items: center;
  margin-right: 35px;
  .icon_hover {
    &:hover {
      color: #0b5cf3;
      cursor: pointer;
    }
  }
  .margin_right {
    margin-right: 15px;
    cursor: pointer;
  }
  .wrap_avatar {
    display: inline-block;
    padding: 11px 0;
    margin-left: 15px;
    .avatar {
      margin-right: 6px;
    }
  }
  .wrap_droparea {
    width: 162px;
    cursor: pointer;
    > li {
      display: flex;
      align-items: center;
      height: 50px;
      padding: 0 20px;
      .sicon {
        color: #89a0c0;
        margin-right: 15px;
      }
      &:hover {
        background: rgba(237, 243, 254, 1);
        > span {
          color: #3091ff;
        }
        .sicon {
          color: #3091ff;
        }
      }
    }
  }
}
</style>
